module.exports = __webpack_public_path__ + "static/img/aidingzhi2.acd3568.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/aidingzhi2.png
// module id = avNe
// module chunks = 1